import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { CustomerSelectSearch } from "../../customers/components";

interface IContactForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const ContactForm: React.FC<IContactForm> = ({
  loading,
  form,
  submit,
}) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <CustomerSelectSearch form={form} name="customerId" />
        <Input label="Civilité" className="w-full" {...form.register("civility", { required: true })} />
        <Input
          label="Prénom"
          className="w-full"
          {...form.register("firstname", { required: "Prénom requis" })}
        />
        <Input label="Nom" className="w-full" {...form.register("lastname")} />
        <Input label="Email" className="w-full" {...form.register("email")} />
        <Input
          label="Téléphone"
          className="w-full"
          {...form.register("phone", { required: "Téléphone requis" })}
        />
        <Textarea label="Notes" className="w-full" {...form.register("notes")} />
        <label className="w-full flex items-center gap-2">
          <input type="checkbox" {...form.register("isPrimary")} />
          <span className="text-sm">Contact principal</span>
        </label>
        <label className="w-full flex items-center gap-2">
          <input type="checkbox" {...form.register("active")} defaultChecked />
          <span className="text-sm">Actif</span>
        </label>
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
